import React from 'react';
import ReactDOM from 'react-dom';
import { MetricsProvider, MetricsLogger } from '@cabify/prom-react';
import * as PIXI from 'pixi.js';
import { install } from '@pixi/unsafe-eval';
import Chart from 'chart.js';
import 'chart.js/dist/Chart.css';
import routes from './routes';
import App from './App';

install(PIXI);
Chart.platform.disableCSSInjection = true;

const getPageName = (path: string) => {
  if (routes) {
    const routeComponent = routes.find((route) => path.indexOf(route.path) >= 0)?.component;
    return routeComponent?.name || 'unknown';
  }
  return 'unknown';
};

ReactDOM.render(
  <MetricsProvider
    appName="il-lighting-ui"
    owner="Intelligent Lighting"
    getNormalizedPath={getPageName}
    // metricsAggregatorUrl="https://tbd"
  >
    {process.env.NODE_ENV !== 'production'
        && <MetricsLogger />}
    <App />
  </MetricsProvider>,
  document.getElementById('root'),
);
